import styled from 'styled-components'

const styledComponent = styled.span`
  display: block;
`

styledComponent.displayName = 'OrderAvatarTextRow'
export default styledComponent
